export default __webpack_public_path__ + "static/B0268-b153a912733d52c78188419397d987dd.png";